<template lang='pug' src='./blog-post.pug'></template>

<script>
import Loader from 'components/loader/loader'
import FooterMain from 'components/footer/footer'

export default {
  name: 'blog-post',
  computed: {
    props () {
      return this.$store.state.sortedBlog[this.$route.params.id]
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    FooterMain
  }
}
</script>



// WEBPACK FOOTER //
// blog-post.vue?87b05c08